import { Icon, TextButton, useAppPalette } from "@bridgesplit/ui";
import { FilterConfig, FilterProps } from "@bridgesplit/abf-react";

export function ResetAllFiltersButton<C extends FilterConfig>({
    filterProps,
    close,
    showIcon = true
}: {
    filterProps: FilterProps<C>;
    close?: () => void;
    showIcon?: boolean;
}) {
    const { defaultState, setFilters } = filterProps;
    const { secondary } = useAppPalette();

    return (
        <TextButton
            color="secondary"
            onClick={() => {
                setFilters(defaultState);
                close?.();
            }}
            textProps={{
                sx: { fontWeight: "normal", color: secondary }
            }}
            startIcon={showIcon && <Icon type="reject" sx={{ color: secondary }} />}
        >
            Reset all
        </TextButton>
    );
}
